import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

import { useIsOnboarding } from '@components/OnboardingAccessControl';
import { useCheckPermission } from '@services/auth/hooks';
import { useShop } from '@services/ShopProvider';

export const Home = () => {
	const params = useParams();
	const { data: shops } = useShop();
	const { user } = useUser();
	const hasInsightsPermission = useCheckPermission('org:insights:read');
	const isOnboarding = useIsOnboarding();

	// Check if user is a Unify user who hasn't completed onboarding
	const isUnifyUser = user?.unsafeMetadata?.product === 'unify';
	const onboardingComplete = user?.unsafeMetadata?.onboardingComplete;

	if (!shops.length) {
		// Redirect Unify users who haven't completed onboarding
		if (isUnifyUser && !onboardingComplete) {
			return <Navigate replace to="/unify-onboarding" />;
		}
		return <Navigate replace to="/no-shops" />;
	}

	const homepage = hasInsightsPermission ? '/dashboard' : '/orders';

	let shopId;
	const isIndie = shops.length === 1;
	if (isIndie) shopId = shops[0].id;
	if (params?.shopId) shopId = params.shopId;

	if (isOnboarding) {
		return <Navigate replace to={`/onboarding${shopId ? '/' + shopId : ''}`} />;
	}

	return <Navigate replace to={`${homepage}${shopId ? '/' + shopId : ''}`} />;
};
